import { useMemo, useState } from "react";
import Link from "next/link";

import { clsxMerge } from "shared/lib/helpers";
import { CloseIcon } from "shared/ui/icons";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

import { meetingsToastEmitter } from "..";
import {
  CustomQualifiedMeetingsToastI,
  MeetingQualifiedToastI,
} from "@/lib/types/custom-toasts/meetings";
import { CampaignLogo } from "@/components/base/campaign-logo";
import { widgets, WIDGETS_ENUM } from "@/widgets/index";

interface QualifiedMeetingToastI extends PropsWithClassNameI {
  toastData: CustomQualifiedMeetingsToastI;
}

const QualifiedMeetingToast = ({
  toastData,
  className,
}: QualifiedMeetingToastI) => {
  const [renderToast, setRenderToast] = useState(true);

  const handleClose = () => {
    setRenderToast(false);
    meetingsToastEmitter.dismiss();
  };

  const {
    campaign_id,
    campaign_name,
    payout,
    user_name,
    contact_title,
    account_name,
    circle_post_url,
    recording_url,
  }: MeetingQualifiedToastI = useMemo(
    () => toastData.data || {},
    [toastData.data]
  );

  const handleOpenQMCirclePost = () => {
    if (circle_post_url) {
      widgets.open({
        id: WIDGETS_ENUM.SALES_FLOORS,
        config: {
          salesFloorPostByURL: circle_post_url,
        },
      });
    }
  };

  return renderToast ? (
    <div
      className={clsxMerge(
        "w-[600px]",
        "p-5",
        "transition-opacity duration-500 ease-out",
        "animate-in fade-in",
        "gap-0 overflow-hidden rounded-xl border-2 text-white shadow-[0px_4px_88px_rgba(0,0,0,0.06)]",
        "bg-[linear-gradient(273deg,_#000_82.66%,_#535353_99.29%)]",

        className
      )}
    >
      <div className="flex">
        <div className="flex items-center">
          <CampaignLogo
            campaignId={campaign_id}
            defaultBgColor="bg-white"
            className="min-h-[60px] min-w-[60px] rounded-xl"
          />
          <div className="relative top-1 ml-6 flex flex-col justify-center">
            <h4 className="ae-typography-h4 mb-1">{campaign_name}</h4>

            <p className="ae-typography-body2 mb-3 line-clamp-2">
              <b>{`${user_name} booked a qualified meeting🔥`}</b> worth{" "}
              <b>${payout}</b> with a {contact_title} from {account_name}{" "}
              account
            </p>
          </div>

          {circle_post_url ? (
            <button
              onClick={handleOpenQMCirclePost}
              className="btn-b-white ml-4 w-[120px]"
            >
              Listen
            </button>
          ) : (
            <Link
              href={recording_url || ""}
              target="_blank"
              className="btn-b-white ml-4 w-[120px]"
            >
              Listen
            </Link>
          )}

          <div>
            <button
              className="btn btn-circle btn-ghost btn-sm"
              onClick={handleClose}
            >
              <CloseIcon className="ml-6 min-w-6" />
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default QualifiedMeetingToast;
